import { http } from "@next-core/http";
/**
 * @description 查询协作空间业务流列表
 * @endpoint GET /api/v1/elevo/spaces/:spaceId/service-flows
 */
export const ElevoSpaceApi_listServiceFlow = async (spaceId, params, options) => /**! @contract easyops.api.llm.elevo_space.ListServiceFlow@1.0.0 */(await http.get(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/service-flows`, {
  ...options,
  params
})).data;
//# sourceMappingURL=listServiceFlow.js.map